import { render, staticRenderFns } from "./ConfigMapping.vue?vue&type=template&id=3d77cb3c"
import script from "./ConfigMapping.vue?vue&type=script&lang=js"
export * from "./ConfigMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports